import { ActivatedRoute } from '@angular/router';

/**
 * Gets the Google Analytics event for the current step from route data.
 * This is used by both QT Lite and Online QT to get the Google Analytics event
 * associated with the current step.
 *
 * @param route - The activated route to extract step event from
 * @returns The Google Analytics event name for the current step, or undefined if not found
 *
 * @example
 * const stepEvent = getStepEvent(this.route);
 * if (stepEvent) {
 *   this.googleAnalyticsService.trackViewEvent(stepEvent);
 * }
 */
export function getStepEvent(route: ActivatedRoute): string | undefined {
  let currentRoute = route;
  while (currentRoute.firstChild) {
    currentRoute = currentRoute.firstChild;
  }
  return currentRoute.snapshot.data?.step?.googleAnalyticsEvent;
}
